/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { resetForm } from '@insticator/insticator-ui';
import { setFormEditableState, discardChanges } from '@insticator/insticator-ui';
import { sendErrorMessage } from '@insticator/insticator-ui'; // iui-state
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { savePaymentInformationWithValidation, getPaymentInformation, changePaymentType } from 'state/actions/accountState/account_data';
// component
import SelectMethod from 'pages/dashboard/account/paymentinfo/selectmethod/selectmethod';



/* ========== ~~~~~~~~~~ ACCOUNT SELECT PAYMENT METHOD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    formName: accountData.selectedPaymentType,
    selectedPaymentType: accountData.selectedPaymentType,
    preferredPaymentType: accountData.preferredPaymentType,
    payoutThreshold: accountData.payoutThreshold,
    savedPaymentTypes: accountData.savedPaymentTypes,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    changePaymentType: (paymentType) => dispatch(changePaymentType(paymentType)),
    sendErrorMessage: (message) => dispatch(sendErrorMessage(message)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectMethod);
